<template>
    <div class="patient">
        <div class="title">患者管理</div>
        <div class="search">
            <!-- <p> <el-select v-model="value" placeholder="医院名称" >
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    />
                </el-select>
            </p> -->
            <p>{{ userStore.hospital }}</p>
            <p><el-input v-model="selectname" placeholder="患者姓名" @blur="serch"></el-input></p>

        </div>
        <div class="items">
            <div v-for="(item, index) in tableData" :key="index" class="item" @click="details(item)">
                <div class="name">
                    <p class="head_name">{{ item.patient_name }}</p>
                    <div class="item_state">
                        <p v-if="item.visitis_state" class="ok">全部完成</p>
                        <p v-else class="not_ok">访视中</p>
                    </div>
                </div>
                <div class="info">
                    <p class="card"><span>身份证后六位 | {{ item.id_card??'无' }}</span></p>
                    <p>入组时间：{{item.enrollment_time??'未填写'}}</p>
                </div>
            </div>
        </div>
    </div>
    <el-drawer v-model="selectshow"  :with-header="false" :destroy-on-close="true"
             :close-on-click-modal="true" :close-on-press-escape="false" 
             @close="handleCloseDrawer" direction="btt" size="40%" class="box">
             <div>
                <p class="name">{{ patientname }}</p>
                <p class="fsq">请选择上传报告的访视期</p>
                <p class="selects"> 
                    <el-select v-model="report" placeholder="访视期" class="select" >
                    <el-option
                        v-for="item in reportlist"
                        :key="item"
                        :label="item"
                        :value="item"
                        />
                </el-select>
            </p>
             </div>
            <div class="btn">
                <p @click="handleCloseDrawer">取消</p>
                <p @click="topatient">确认</p>
            </div>
        

  </el-drawer>
</template>
<script setup>
import { ref , onMounted} from 'vue'
import { usePatientStore } from "@/stores/patient";
import { useCrfStore } from "@/stores/crf";
import { useRouter, useRoute} from 'vue-router';
import { useCommonStore } from "@/stores/common.js";
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

// 表头信息（访视期，包含的每块）
const crfStore = useCrfStore();
let crfForms = crfStore.forms;
const patientStore = usePatientStore();
//搜索患者姓名
const selectname = ref('')

const serch = () => {
    lists()
}

const options = [
  {
    value: 'Option1',
    label: 'Option1',
  },
  {
    value: 'Option2',
    label: 'Option2',
  },
  {
    value: 'Option3',
    label: 'Option3',
  },
  {
    value: 'Option4',
    label: 'Option4',
  },
  {
    value: 'Option5',
    label: 'Option5',
  },
];

const selectshow = ref(false)
// 患者名字
const patientname = ref('')
// 患者id
const patientid = ref('')
// 患者访视期
const report = ref('')
//患者访视期列表
const reportlist = ref([])
// 点击跳转详情页
const topatient = ()=>{
    console.log()
    if(report.value == '') return alert('请选择访视期')
    router.push({name:'detailsApp',query:{id:patientid.value,report:report.value}})
    report.value = ''
}
//保存点击患者的信息
const details = async (item) =>{
    console.log(item,'item')
    patientname.value = item.patient_name
    patientid.value = item.id
    // report.value = item.report
    let res = await useCommonStore().getperiods(item.id)
    console.log(res,'res')
    reportlist.value = res.data
    selectshow.value = true

    // router.push({name:'bbb',query:{id:id,report:'V0肝穿点±2周.'}})
}
const handleCloseDrawer = ()=>{
    selectshow.value = false
}
const tableData = ref([])
const lists =async () => {
    let res =await useCommonStore().getpatients(userStore.id,selectname.value)
    console.log(res, 'res')
    tableData.value = res.data

}
onMounted(() => {
    lists()
})






;
</script>
<style lang="less" scoped>
.patient{
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    .title{
        font-size: 24px;
        margin-bottom: 20px;
        text-align: center;
    }
    .search{
        p{
            width: 100%;
        }
        :deep(.el-select) {
            width: 100%;
            font-family: ArialMT;
            font-size: 14px;
            color: #000000;
        }
    }
    .items{
        .item{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            border-bottom: #aca9a9 solid 1px;
            .name{
                display: flex;
                flex-direction: column;
                width: 30%;
                .head_name{
                    margin: 0;
                }
                .item_state{
                    margin-top: 8px;
                    p{
                        margin: 0 ;
                        padding-left: 10px;
                        font-size: 13px;
                        position: relative;

                    }
                    p::before{
                        content: '';
                        position: absolute;
                        top: 35%;
                        left: 0;
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                    }
                    
                    .ok{
                        color:  #236835;
                    }
                    .ok::before{
                        background: #66A978;
                    
                    }
                    .not_ok::before{
                        background: #D84357;
                    
                    }
                    .not_ok{
                        color:  #D84357;
                    }
                }
            }
            .info{
                width: 60%;
                color:rgb(135, 133, 133) ;
                font-size: 14px;
                p{
                    margin:0;
                    height: 30px;
                }
                

            }
             
        }
    }
}
.box{
    padding: 15px;
    position: relative;
    // height: 400px;
    .name{
        font-size: 18px;
        // font-weight: bold;
        margin-bottom: 10px;
    }
    .fsq{
        font-size: 14px;
        color: rgb(135, 133, 133);
    }
    .select{
        width: 100%;
        .el-select{
            width: 100%;
        }
    }
    .btn{
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 10px;
        // margin-top: 40px;
        width: 100%;
        left: 0;
            box-sizing: border-box;
            padding: 0 20px;


        p{
            background-color: #6A7BFF;
            width: 50%;
            text-align: center;
            color: #fff;
            font-size: 16px;
            line-height: 30px;
    
        };
        p:nth-child(1){
            background-color:#f7f4f4;
            color: #000;
        }
    }
}
</style>